import { load } from 'js-yaml';
import type { NOTAMData } from '@/data/types';

// Import the YAML file as text using Vite's raw import
import notamYamlContent from '@/data/notams.yaml?raw';

export function loadNOTAMData(): NOTAMData {
  try {
    const data = load(notamYamlContent) as NOTAMData;
    return data;
  } catch (error) {
    console.error('Error parsing NOTAM YAML data:', error);
    return { notams: [] };
  }
}